import { NgClass } from '@angular/common';
import { Component, effect, input, output } from '@angular/core';
import { tap } from 'rxjs';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import {
  ConfirmModalComponent,
  TConfirmModalParams,
} from 'src/app/project/components/confirm-modal/confirm-modal.component';
import { ModalService } from 'src/app/project/components/modal/modal.service';
import { SpinnerModule } from 'src/app/project/components/spinner/spinner.module';
import { TooltipsModule } from 'src/app/project/features/tooltip/tooltips.module';
import { TranslationPipe } from 'src/app/project/features/translate/translation.pipe';
import { iconMap } from 'src/app/project/shared/enums/icon-map';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { getTableStatusSrc } from 'src/app/project/shared/status-to-image';
import { IconModule } from '../../icon/icon-module';
import { TRelatedPoint } from '../related-points.consts';
import { RelatedPointsService } from '../related-points.service';

@Component({
  selector: 'pp-related-point-row',
  imports: [IconModule, PipesModule, SpinnerModule, TooltipsModule, NgClass],
  templateUrl: './related-point-row.component.html',
  styleUrl: './related-point-row.component.scss',
})
export class RelatedPointRowComponent {
  ppCanDelete = input.required<boolean>();
  ppRelatedPoint = input.required<TRelatedPoint>();
  ppPointId = input.required<string>();
  ppWorkspaceId = input.required<string>();
  ppIsNewPoint = input.required<boolean>();
  ppDeleteRelation = output<null>();

  iconMap = iconMap;
  EIconPath = EIconPath;
  priorityClass: string;
  statusSrc: string;
  deleting = false;

  constructor(
    private relatedPointsService: RelatedPointsService,
    private modalService: ModalService,
    private translationPipe: TranslationPipe,
  ) {
    effect(() => {
      this.priorityClass = 'relatedPoint__priority--' + this.ppRelatedPoint().pointPriority;

      this.statusSrc = getTableStatusSrc(this.ppRelatedPoint().pointStatus);
    });
  }

  deleteRelation(): void {
    this.modalService.setData<TConfirmModalParams>({
      message: this.translationPipe.transform('confirm_delete_relation'),
      heading: this.translationPipe.transform('confirm'),
      redButton: true,
      confirmText: this.translationPipe.transform('delete_relation'),
    });

    this.modalService.showModal(ConfirmModalComponent, {
      closeWarning: true,
      callback: () => {
        this.relatedPointsService
          .deleteRelation({
            pointId: this.ppPointId(),
            relatedPointId: this.ppRelatedPoint().pointId,
            workspaceId: this.ppWorkspaceId(),
            isNewPoint: this.ppIsNewPoint(),
          })
          .pipe(
            tap(() => {
              this.ppDeleteRelation.emit(null);
            }),
          )
          .subscribe();
      },
    });
  }

  openPoint(): void {
    if (this.ppIsNewPoint()) {
      return;
    }

    this.relatedPointsService.openRelatedPoint({
      pointId: this.ppRelatedPoint().pointId,
      workspaceId: this.ppRelatedPoint().siteId,
    });
  }
}
